import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100vw',
    minHeight: ({ smallMedia }) => (smallMedia ? '0' : '600px'),
    height: '100svh',
    maxHeight: ({ smallMedia, hideMobileFooter }) =>
      smallMedia && !hideMobileFooter ? 'calc(100svh - 64.5px)' : 'unset',
    overflow: 'hidden',
    backgroundColor: '#F0F0F0',

    '& .MuiAvatar-img': {
      background: 'rgba(173, 194, 204, 0.9)'
    }
  },

  children: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  }
}))

export default useStyles
